import { Component } from '@angular/core';
import { FormFieldAbstractComponent } from '../form-field-abstract/form-field-abstract.component';

@Component({
  selector: 'astrade-form-field-textarea',
  template: `
    <mat-form-field fxFlex>
      <mat-label>{{ label }}</mat-label>
      <textarea matInput [formControl]="control"></textarea>
      <button type="button" *ngIf="hint" [matTooltip]="hint" matTooltipClass="hint" mat-icon-button matSuffix><mat-icon>help</mat-icon></button>
    </mat-form-field>
  `
})
export class FormFieldTextareaComponent extends FormFieldAbstractComponent {

}
